import React from "react";

import "./OptionContainerWrapper.scss";

interface IProps {
    children?: React.ReactNode;
}

export default function OptionContainerWrapper(props: IProps) {
    // TODO: Implement logic

    return <div className={`userful-opiton-container-wrapper`}>{props.children}</div>;
}
